const glossaryItems = [
  ["Abeam", "abeam", "A direction at right angles to the vessel's centerline, directly off the port or starboard side."],
  ["Abaft", "abaft", "Toward the stern or behind a reference point on a vessel."],
  ["Aft", "aft", "Toward the rear or stern of a boat."],
  ["Amidships", "amidships", "The middle section of a vessel, halfway between bow and stern."],
  ["Anchor", "anchor", "A heavy device used to hold a vessel in place by gripping the seabed."],
  ["Anchorage", "anchorage", "A suitable area where vessels can safely anchor."],
  ["Apparent Wind", "apparent-wind", "The wind experienced onboard, combining true wind and the vessel's motion."],
  ["Astern", "astern", "Behind the vessel or moving backward."],
  ["Athwartships", "athwartships", "Across the vessel from side to side."],
  ["Backstay", "backstay", "A stay running from the mast toward the stern to support the rig."],
  ["Ballast", "ballast", "Weight placed low in a vessel to improve stability."],
  ["Barometer", "barometer", "An instrument measuring atmospheric pressure for weather forecasting."],
  ["Beam", "beam", "The widest part of a vessel."],
  ["Beam Reach", "beam-reach", "A point of sail where the wind comes from roughly 90 degrees to the boat."],
  ["Bearing", "bearing", "The direction from one point to another, usually measured in degrees."],
  ["Berth", "berth", "A place where a vessel is moored or a sleeping space onboard."],
  ["Bilge", "bilge", "The lowest internal part of a boat where water may collect."],
  ["Bitter End", "bitter-end", "The final end of a rope, line, or anchor cable."],
  ["Boom", "boom", "A horizontal spar attached to the mast that controls the foot of a sail."],
  ["Bow", "bow", "The front part of a vessel."],
  ["Bowsprit", "bowsprit", "A spar extending forward from the bow to support headsails."],
  ["Broad Reach", "broad-reach", "A point of sail with wind coming from behind the beam."],
  ["Buoy", "buoy", "A floating navigation marker or mooring aid."],
  ["Cabin", "cabin", "An enclosed living or working space onboard."],
  ["Capsize", "capsize", "When a vessel overturns in the water."],
  ["Chartplotter", "chartplotter", "An electronic navigation display showing charts and vessel position."],
  ["Cleat", "cleat", "A fitting used to secure lines onboard or ashore."],
  ["Close Hauled", "close-hauled", "Sailing as close to the wind as the vessel can efficiently manage."],
  ["Close Reach", "close-reach", "A point of sail between close hauled and beam reach."],
  ["Cockpit", "cockpit", "The area where the helm and crew operate the vessel."],
  ["COLREGs", "colregs", "International collision prevention rules governing vessel behavior at sea."],
  ["Compass", "compass", "A navigation instrument showing direction relative to magnetic north."],
  ["Course Over Ground", "course-over-ground", "The actual direction a vessel moves over the earth's surface."],
  ["Dead Reckoning", "dead-reckoning", "Estimating position using course, speed, time, and previous position."],
  ["Deck", "deck", "The horizontal working surface of a vessel."],
  ["Dinghy", "dinghy", "A small boat often used as a tender for a larger vessel."],
  ["Displacement", "displacement", "The weight of water a vessel displaces, closely related to vessel weight."],
  ["Draft", "draft", "The depth of water required for a vessel to float safely."],
  ["Fairlead", "fairlead", "A fitting that guides a line to reduce chafe and improve control."],
  ["Fathom", "fathom", "A nautical depth unit equal to six feet."],
  ["Fender", "fender", "A cushion placed between a vessel and dock or another vessel."],
  ["Flare", "flare", "A visual distress signal used in emergencies."],
  ["Foredeck", "foredeck", "The forward deck area near the bow."],
  ["Forestay", "forestay", "A stay running from mast to bow to support the mast and headsail."],
  ["Freeboard", "freeboard", "The vertical distance from waterline to deck edge."],
  ["Galley", "galley", "The kitchen area onboard a vessel."],
  ["Genoa", "genoa", "A large overlapping headsail used on sailing yachts."],
  ["Gimbals", "gimbals", "Pivoting mounts that keep equipment level as a boat heels."],
  ["Gooseneck", "gooseneck", "The fitting connecting the boom to the mast."],
  ["Ground Tackle", "ground-tackle", "Anchoring equipment including anchor, chain, rode, and fittings."],
  ["Gunwale", "gunwale", "The upper edge of a boat's side."],
  ["Halyard", "halyard", "A line used to raise or lower sails and flags."],
  ["Harbor", "harbor", "A sheltered water area where vessels can moor or anchor."],
  ["Hatch", "hatch", "An opening in the deck or cabin for access, light, or ventilation."],
  ["Head", "head", "A marine toilet or bathroom compartment."],
  ["Heading", "heading", "The direction a vessel's bow is pointing."],
  ["Headsail", "headsail", "A sail set forward of the mast, such as a jib or genoa."],
  ["Heave To", "heave-to", "A storm or pause maneuver that balances sails and rudder to slow the boat."],
  ["Heel", "heel", "The leaning of a sailing vessel under wind pressure."],
  ["Helm", "helm", "The steering position or steering control of a vessel."],
  ["Hull", "hull", "The main body of a vessel."],
  ["Jib", "jib", "A triangular headsail set forward of the mast."],
  ["Jibe", "jibe", "Changing tack with the stern passing through the wind."],
  ["Keel", "keel", "A structural fin or backbone below the hull providing stability and tracking."],
  ["Knot", "knot", "A nautical speed unit equal to one nautical mile per hour."],
  ["Latitude", "latitude", "A geographic coordinate measuring distance north or south of the equator."],
  ["Leeway", "leeway", "Sideways drift caused by wind or current."],
  ["Leeward", "leeward", "The side sheltered from the wind."],
  ["Lifeline", "lifeline", "Safety railing or wire around a vessel's deck."],
  ["Logbook", "logbook", "A record of voyage details, navigation, weather, and events."],
  ["Longitude", "longitude", "A geographic coordinate measuring distance east or west of Greenwich."],
  ["Mainsail", "mainsail", "The principal sail set on the main mast."],
  ["Marina", "marina", "A facility offering berths and services for boats."],
  ["Mast", "mast", "A vertical spar supporting sails and rigging."],
  ["Mayday", "mayday", "The international radio distress call for grave and imminent danger."],
  ["Mooring", "mooring", "A fixed system or place for securing a vessel."],
  ["Nautical Mile", "nautical-mile", "A marine distance unit equal to one minute of latitude."],
  ["Port", "port", "The left side of a vessel when facing forward."],
  ["Reef", "reef", "To reduce sail area for stronger winds or safer handling."],
  ["Rigging", "rigging", "The wires, ropes, and fittings supporting and controlling sails."],
  ["Rudder", "rudder", "An underwater control surface used to steer a vessel."],
  ["Sail Trim", "sail-trim", "Adjusting sails for efficient power, balance, and control."],
  ["Sea State", "sea-state", "The condition of the sea surface based on waves and swell."],
  ["Sheet", "sheet", "A line used to control the angle of a sail."],
  ["Skipper", "skipper", "The person responsible for command and safety of a vessel."],
  ["Spinnaker", "spinnaker", "A large downwind sail used for sailing with wind from behind."],
  ["Starboard", "starboard", "The right side of a vessel when facing forward."],
  ["Stern", "stern", "The rear part of a vessel."],
  ["Tack", "tack", "Changing direction with the bow passing through the wind, or the lower forward sail corner."],
  ["Tide", "tide", "The periodic rise and fall of sea level caused mainly by lunar and solar gravity."],
  ["True Wind", "true-wind", "The actual wind direction and speed relative to the earth."],
  ["VHF Channel", "vhf-channel", "A marine radio channel used for vessel communication and safety."],
  ["Wake", "wake", "The disturbed water left behind a moving vessel."],
  ["Waypoint", "waypoint", "A defined navigation position used for route planning."],
  ["Windward", "windward", "The side facing or toward the wind."],
  ["Yaw", "yaw", "A vessel's side-to-side rotation around its vertical axis."]
];

export const comprehensiveGlossaryLinks = glossaryItems.map(([label, slug, definition]) => ({
  label,
  href: `/glossary/${slug}`,
  description: definition,
}));

export const comprehensiveGlossaryTerms = Object.fromEntries(
  glossaryItems.map(([label, slug, definition]) => [
    slug,
    {
      title: label,
      description: definition,
      highlights: [
        "Plain-language maritime definition",
        "Useful for sailing and skipper training",
        "Connected to onboard communication",
        "Relevant for route and safety planning",
        "Search-friendly nautical terminology",
        "Part of the Marstick maritime glossary",
      ],
      faqs: [
        { question: `What does ${label} mean in boating?`, answer: definition },
        { question: `Why is ${label} important?`, answer: "Understanding maritime terms improves communication, safety, and confidence during planning and onboard operations." },
      ],
    },
  ])
);